<template>
  <div class="workspace">
    <TopHeader />
    <Navi />
    <fluidCover />
    <fluidBend />
    <div class="wrapper">
      <b-container>
        <LectureWelcomeBox />
      </b-container>
      <b-container fluid>
        <EventBox />
      </b-container>
    </div>
  </div>
</template>

<script>
import TopHeader from "@/components/Header";
import Navi from "@/components/Navi";
import FluidCover from "@/components/FluidCover";
import FluidBend from "@/components/FluidBend";
import LectureWelcomeBox from "@/components/LectureWelcomeBox";
import EventBox from "@/components/EventBox";

import SimpleChart from "@/components/SimpleChart.js";

export default {
  components: {
    TopHeader,
    Navi,
    FluidCover,
    FluidBend,
    LectureWelcomeBox,
    EventBox,
    // SimpleChart,
  },
};
</script>


<style lang="scss" scoped>
.wrapper {
  padding-top: 50px;
  padding-bottom: 25px;
}
</style>